import instance from './instance';
import { token } from '../../auth';
import i18n from '../../../i18n';

export default class API {
  constructor(config = {}) {
    this.path = config.path;

    this.axios = instance();
  }

  get config() {
    return {
      headers: {
        Authorization: `token=${token.get()}`,
        'Content-Language': i18n.locale,
      },
    };
  }

  get(resource = '', config = {}) {
    return this.axios.get(`${this.path}/${resource}`, Object.assign({}, this.config, config));
  }

  put(resource = '', data, config = {}) {
    return this.axios.put(`${this.path}/${resource}`, data, Object.assign({}, this.config, config));
  }

  post(data, config = {}, resource = '') {
    const path = `${this.path}/${resource}`;

    return this.axios.post(path, data, Object.assign({}, this.config, config));
  }

  delete(resource = '', config = {}) {
    return this.axios.delete(`${this.path}/${resource}`, Object.assign({}, this.config, config));
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/api/index.js
 **/